export const SCORE_KEYS_TYPES = ["digit", "word", "sentence", "object", "array-sentence", "array-object"]